/**
 * The two seeded demo tenants (see supabase/seeds/demo_accounts.sql).
 * Features that can only be simulated today — e.g. the document
 * scanner — are enabled for these accounts only, so a real operator
 * never gets made-up data saved against their property.
 */
export const DEMO_ACCOUNT_EMAILS = [
  "hotel-demo@diyafa.tech",
  "rental-demo@diyafa.tech",
] as const;

export function isDemoAccount(email: string | null | undefined): boolean {
  return !!email && (DEMO_ACCOUNT_EMAILS as readonly string[]).includes(email.toLowerCase());
}

export type DemoKind = "hotel" | "rental";

/** Public sign-in for the seeded demo tenants, used by the one-click
 *  "Try the demo" buttons on the home page and in the sign-in modal. */
export const DEMO_CREDENTIALS: Record<DemoKind, { email: string; password: string }> = {
  hotel:  { email: "hotel-demo@diyafa.tech",  password: "DemoHotel2026!" },
  rental: { email: "rental-demo@diyafa.tech", password: "DemoRental2026!" },
};
